<template>
  <BookmarkCard :tag-type="tagType" icon-name="comment-alt">
    <template #content>
      <slot></slot>
    </template>
  </BookmarkCard>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import BookmarkCard from "../generic_components/BookmarkCard.vue"
import { TAG_TYPES_FOR_BOOKMARK_CARD } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "RecapCard",
  components: { BookmarkCard },
  data() {
    return {
      tagType: TAG_TYPES_FOR_BOOKMARK_CARD.RECAP,
    }
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.BookmarkCard {
  &.recap {
    height: auto;

    .BookmarkCard-tag,
    .BookmarkCard-icon {
      background-color: $ofb-bleu-1;
    }

    .BookmarkCard-card {
      max-width: 700px;
      height: 250px;
      width: 40vw;
      margin-top: -50px;
    }

    .BookmarkCard-tag {
      width: 150px;
      font-size: 0.8em;
    }

    .BookmarkCard-icon {
      width: 150px;
      margin-top: -50px;
    }

    .BookmarkCard-footer {
      display: none;
    }
  }
}
</style>
